import { ROLES, type Role } from '@/features/auth/types';

const LEGACY_ALIASES = new Set(['ADMIN', 'VENDEDOR', 'CONSULTOR']);

/** Rótulos amigáveis de todos os papéis do sistema (fonte única). */
export const ROLE_LABELS: Record<string, string> = {
  [ROLES.SUPER_ADMIN]: 'Super Admin',
  [ROLES.REPRESENTANTE]: 'Representante',
  [ROLES.ASSOCIADO]: 'Associado',
  [ROLES.SECRETARIA]: 'Secretaria',
  [ROLES.SUPERVISOR]: 'Supervisor',
  [ROLES.RELACIONADOR]: 'Relacionador',
  [ROLES.LIDER_VENDAS]: 'Líder de Vendas',
  [ROLES.POS_VENDA]: 'Pós-venda',
  [ROLES.USER]: 'Consultor',
  // Legados / aliases
  ADMIN: 'Associado',
  VENDEDOR: 'Líder de Vendas',
  CONSULTOR: 'Relacionador',
};

/** Normaliza e devolve o label legível do perfil; nunca deixa enum cru sem fallback. */
export function getRoleLabel(role?: string | null): string {
  if (!role) return 'Não definido';
  const key = role.trim().toUpperCase();
  return ROLE_LABELS[key] ?? humanizeRole(role);
}

function humanizeRole(role: string): string {
  return role
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Opções de select com labels padronizados (sem aliases legados). */
export function getRoleOptions(exclude: Array<Role | string> = []) {
  const excluded = new Set(exclude.map((r) => String(r).toUpperCase()));
  return Object.entries(ROLE_LABELS)
    .filter(([value]) => !LEGACY_ALIASES.has(value) && !excluded.has(value))
    .map(([value, label]) => ({ value, label }));
}
